import Breadcrumb from 'react-bootstrap/Breadcrumb';
import styled from "styled-components";
// @ts-ignore
import Link from "next/link";
import {IBreadcrumb} from "../interfaces/IBreadcrumb";
import Icon from "./Icon";
import {getNavPath} from "../shared/navigateUtil";
import {useRouter} from "next/router";
import useHorizontalScroll from "../hooks/useHorizontalScroll";
import {getTheme} from "../shared/themeUtils";

const ScrollHide = styled.div`
  overflow: hidden;
  height: 34px;
    margin-bottom: ${getTheme("space.1")};
  position: relative;
`;

const BreadcrumbsContain: any = styled.div`
  display: flex;
  align-items: center;
  font-size: ${getTheme("fontSizes.small")};
  overflow: auto;
  padding-bottom: ${getTheme("space.2")};

  ol {
    margin: 0;
    display: block;
    overflow: auto;
    white-space: nowrap;
    padding-left: 42px;

    .breadcrumb-item {
      display: inline-block;
    }
  }
  .home-link {
    padding: 6px 6px 12px 12px;
    position: absolute;
    left: 0;
    bottom: 3px;
    top: -2px;
    z-index: 9;
    cursor: pointer;
    margin-right: ${getTheme("space.1")};
  }
  .home-link svg {
    position: relative;
    top: 3px;
  }
  .home-link div::before {
    content: '';
    position: absolute;
    left: 0;
    top: 2px;
    height: 100%;
    width: 100%;
    border-radius: 4px 0 0 4px;
    opacity: 1;
    background: ${getTheme("colors.background")};
    z-index: -1;
  }
  .home-link .home::after {
    content: '';
    position: absolute;
    top: 2px;
    right: -8px;
    border-top: 16px solid transparent;
    border-left: 9px solid #fff;
    border-bottom: 16px solid transparent;
    border-left-color: ${getTheme("colors.background")};
    opacity: 1;
    z-index: -1;
  }
  .breadcrumb-item:not(:first-child) {
    position: relative;
    padding: 6px 12px;
    margin-right: ${getTheme("space.0")};
  }
  .breadcrumb-item:not(:first-child)::before {
    content: none;
  }
  .breadcrumb-item:not(:first-child) a::before {
    content: '';
    position: absolute;
    left: 0;
    height: 50%;
    width: 100%;
    background: ${getTheme("colors.background")};
    opacity: 1;
    top: 0;
    transform: skew(30deg);
    z-index: -1;
  }
  .breadcrumb-item:not(:first-child) a::after {
    content: '';
    position: absolute;
    left: 0;
    height: 50%;
    width: 100%;
    background: ${getTheme("colors.background")};
    opacity: 1;
    bottom: 0;
    transform: skew(-30deg);
    z-index: -1;
  }
  }
`

interface BreadcrumbsProps {
  items: IBreadcrumb[];
  className?: string;
}

const Breadcrumbs = (props: BreadcrumbsProps) => {
  const { items, className } = props;
  const router = useRouter()
  const { scrollRef, scrollProps } = useHorizontalScroll("reverse");


  return (
    <ScrollHide>
      <BreadcrumbsContain className={className} ref={scrollRef} {...scrollProps}>
        <Breadcrumb>
          <Breadcrumb.Item linkAs={Link} href={getNavPath(router, "/")} className="home-link">
            <div>
              <Icon variant="xSmall" className="home" color="secondary">home-line</Icon>
            </div>
          </Breadcrumb.Item>
          {
            (items && items.length > 0) && items.map((item: IBreadcrumb, index) =>
              <Breadcrumb.Item key={item.url} linkAs={Link} href={item.url} active={index == (items.length-1)}>{item.text}
              </Breadcrumb.Item>)
          }
        </Breadcrumb>
      </BreadcrumbsContain>
    </ScrollHide>
    
  )
}

export default Breadcrumbs;
